import { useState, useCallback } from 'react';
import classNames from 'classnames';
import styles from './document-card.module.scss';

/**
 * The card's note: a 3-line-clamped paragraph with a "View more" toggle that
 * only appears when the clamp hides text.
 * @param {object} props The note.
 * @param {string} props.note The note text.
 * @return {JSX.Element} The note.
 */
export function DocumentCardNote({ note }: { note: string }) {
  const [showAll, setShowAll] = useState(false);
  const [overflows, setOverflows] = useState(false);
  // A callback ref measures the instant the <p> mounts — for typed docs that's
  // when the expand body mounts, for non-typed when the Notes accordion opens —
  // both of which happen after the card expands, so an effect keyed on the
  // card's expanded state misses them.
  const measure = useCallback(
    (el: HTMLParagraphElement | null) => {
      if (!el || showAll) return;
      setOverflows(el.scrollHeight > el.clientHeight + 1);
    },
    [showAll]
  );
  return (
    <>
      <p
        ref={measure}
        className={classNames(styles.notes, {
          [styles.notesClamped]: !showAll,
        })}
      >
        {note}
      </p>
      {overflows && (
        <button
          type="button"
          className={styles.viewMore}
          onClick={(e) => {
            e.stopPropagation();
            setShowAll((v) => !v);
          }}
        >
          {showAll ? 'View less' : 'View more'}
        </button>
      )}
    </>
  );
}
